'use client'

import { useEffect } from 'react'

export default function GalleryError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Gallery Error:', error)
  }, [error])

  return (
    <div className="container px-4 py-8 mx-auto">
      <h1 className="text-4xl font-bold">Gallery Error</h1>
      <p className="text-foreground">An error occurred while loading the gallery</p>
    </div>
  )
}
